module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list-item', [_c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.collaborator.name))])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.collaborator.role))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.collaborator.email))])]), _vm._v(" "), (_vm.editable) ? _c('md-list-expand', [_c('div', {
    staticClass: "button-row"
  }, [_c('md-button', {
    on: {
      "click": _vm.removeCollaborator
    }
  }, [_c('md-icon', [_vm._v("delete")]), _vm._v("\n                Remove\n            ")], 1), _vm._v(" "), _c('md-button', {
    attrs: {
      "disabled": _vm.isResending
    },
    on: {
      "click": _vm.resendInvitation
    }
  }, [(_vm.isResending) ? _c('md-spinner', {
    attrs: {
      "md-size": 16,
      "md-indeterminate": ""
    }
  }) : _c('md-icon', [_vm._v("email")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.isResending ? 'Sending...' : 'Resend Invitation'))])], 1)], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6500093b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collaborators/pending-collaborator.vue
// module id = 1252
// module chunks = 21